import React, { useEffect, useState } from "react";
import DataTable from "../../Components/DataTable";
import Input, { Label } from "../../Components/Input";
import useFetchData from "../../Hooks/useFetchData";
import useInput from "../../Hooks/useInput";
import Modal from "react-awesome-modal";
import useSave from "../../Hooks/useSave";
import useDeleteData from "../../Hooks/useDeleteData";
import useGetData from "../../Hooks/useGetData";
import Select from "react-select";


const Contacts = () => {
    const [Editing, setEditing] = useState(false);
    const initialState = {
        email: "",
        name: "",
        website: "",
        telephone: "",
        postalAddress: "",
        street: "",
        countyId: "",
        countryId: ""


    };
    const url = "api/Contact/";
    const { response, error, isLoading } = useFetchData(url);

    const { HandleDelete, HandleEditData } = useDeleteData(url);
    const {
        values,
        HandleChange,
        reset,
        FillData,
        handleSelectChange,
        selectOptions
    } = useInput(initialState);
    const [openModel, setOpenModel] = useState(false);

    let TableHeader = ["Name", "Email", "Website", "Telephone", "PostalAddress", "Street", "Country", "County"];
    let rowData = ["name", "email", "website", "telephone", "postalAddress", "street", "country.countryId", "county.countyId"];

    const handleEdit = k => {
        const data = {
            id: k.id,
            email: k.email,
            name: k.name,
            website: k.website,
            telephone: k.telephone,
            postalAddress: k.postalAddress,
            street: k.street
        };
        FillData(data, {
            countyId: {
                value: k.countyId || "",
                label: (k.country || "").name || ""
            },
            countyId: {
                value: k.countyId || "",
                label: (k.county || "").name || ""
            }
        });
        setEditing(true);
    };
    const handleDelete = k => {
        HandleDelete(k.id);
        response.splice(response.indexOf(k), 1);
    };
    const HandleSubmit = e => {
        e.preventDefault();
        handleModel(false)
        useSave(url, values);
        reset();
        response.push(values)
    };
    const HandleUpdate = e => {
        e.preventDefault();
        handleModel(false)
        HandleEditData(values);
        reset();
        response.splice(response.indexOf(values), 1, values);
    };
    const HandleOnClose = e => {
        e.preventDefault();
        setEditing(false);
        handleModel(false);
        reset();
    };
    const handleModel = (e) => {
        setOpenModel(e);
    }
    const handleResetModel = () => {
        setEditing(false);
        reset();
    }
    return (
        <div>
            {isLoading ? (
                <p>Loading</p>
            ) : (
                    <DataTable
                        page={"Contacts"}
                        data={response}
                        HandleOnClose={HandleOnClose}
                        handleEdit={e => handleEdit(e)}
                        handleDelete={e => handleDelete(e)}
                        rowData={rowData}
                        TableHeader={TableHeader}
                        handleModel={(e) => handleModel(e)}
                        handleResetModel={handleResetModel}
                    >
                        <ContactsForm
                            openModel={openModel}
                            handleModel={(e) => handleModel(e)}
                            values={values}
                            selectOptions={selectOptions}
                            IsEditing={Editing}
                            HandleUpdate={HandleUpdate}
                            HandleOnClose={HandleOnClose}
                            HandleSubmit={HandleSubmit}
                            handleSelectChange={handleSelectChange}
                            HandleChange={HandleChange}
                        />
                    </DataTable>
                )}
        </div>
    );
};

export default Contacts;

const ContactsForm = props => {
    const [Countries, Fetch] = useGetData("api/countries");
    const [Counties, FetchCounties] = useGetData("api/counties");


    const CountryOptions = Countries.data.map((k, i) => {
        return {
            value: k.id.toString(),
            label: k.name.toString()
        };
    });
    const CountyOptions = Counties.data.map((k, i) => {
        return {
            value: k.id.toString(),
            label: k.name.toString()
        };
    });

    useEffect(() => {
        Fetch();
        FetchCounties();
    }, []);
    return (
        <Modal visible={props.openModel} width="50%" height="52%" effect="fadeInUp">
            <div className="modal-header">
                <h4 className="modal-title">Add Contact</h4>
                <button
                    onClick={() => props.handleModel(false)}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-hidden="true"
                >
                    ×
                    </button>
            </div>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-6 md-offset-2">
                        <div className="form-group row m-b-10">
                            <Label label="Name" isRequired={true} />
                            <div className="col-md-8">
                                <Input
                                    name="name"
                                    value={props.values.name}
                                    HandleChange={props.HandleChange}
                                />
                            </div>
                        </div>
                        <div className="form-group row m-b-10">
                            <Label label="Email" isRequired={false} />
                            <div className="col-md-8">
                                <Input
                                    name="email"
                                    value={props.values.email}
                                    HandleChange={props.HandleChange}
                                />
                            </div>
                        </div>
                        <div className="form-group row m-b-10">
                            <Label label="Telephone" isRequired={true} />
                            <div className="col-md-8">
                                <Input
                                    name="telephone"
                                    value={props.values.telephone}
                                    HandleChange={props.HandleChange}
                                />
                            </div>
                        </div>
                        <div className="form-group row m-b-10">
                            <Label label="Website" isRequired={false} />
                            <div className="col-md-8">
                                <Input
                                    name="Website"
                                    value={props.values.Website}
                                    HandleChange={props.HandleChange}
                                />
                            </div>
                        </div>
                        <div className="form-group row m-b-10">
                            <Label label="Country" isRequired={true} />
                            <div className="col-md-8">
                                <Select
                                    name="countryId"
                                    className="form-group"
                                    defaultInputValue={props.selectOptions.countryId}
                                    value={props.selectOptions.countryId}
                                    onChange={props.handleSelectChange}
                                    options={CountryOptions}
                                />
                            </div>
                        </div>

                    </div>
                    <div className="col-md-6 md-offset-2">
                        <div className="form-group row m-b-10">
                            <Label label="Postal Address" isRequired={true} />
                            <div className="col-md-8">
                                <Input
                                    name="postalAddress"
                                    value={props.values.postalAddress}
                                    HandleChange={props.HandleChange}
                                />
                            </div>
                        </div>
                        <div className="form-group row m-b-10">
                            <Label label="street" isRequired={false} />
                            <div className="col-md-8">
                                <Input
                                    name="street"
                                    value={props.values.street}
                                    HandleChange={props.HandleChange}
                                />
                            </div>
                        </div>
                        <div className="form-group row m-b-10">
                            <Label label="County" isRequired={true} />
                            <div className="col-md-8">
                                <Select
                                    name="countyId"
                                    className="form-group"
                                    defaultInputValue={props.selectOptions.countyId}
                                    value={props.selectOptions.countyId}
                                    onChange={props.handleSelectChange}
                                    options={CountyOptions}
                                />
                            </div>
                        </div>
                        {/* <div className="form-group row m-b-10">
                            <Label label="Telephone" isRequired={true} />
                            <div className="col-md-8">
                                <Input
                                    name="street"
                                    value={props.values.telephone}
                                    HandleChange={props.HandleChange}
                                />
                            </div>
                        </div>
                        <div className="form-group row m-b-10">
                            <Label label="Website" isRequired={true} />
                            <div className="col-md-8">
                                <Input
                                    name="street"
                                    value={props.values.Website}
                                    HandleChange={props.HandleChange}
                                />
                            </div>
                        </div> */}

                    </div>
                </div>
            </div>

            <div className="modal-footer">
                <a
                    className="btn btn-white"
                    data-dismiss="modal"
                    onClick={props.HandleOnClose}
                >
                    Close
        </a>
                {props.IsEditing ? (
                    <button
                        type="submit"
                        onClick={props.HandleUpdate}
                        className="btn btn-primary"
                    >
                        Update
                    </button>
                ) : (
                        <button
                            type="submit"
                            onClick={props.HandleSubmit}
                            className="btn btn-primary"
                        >
                            Save
                        </button>
                    )}
            </div>
        </Modal>

    );
};
